// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMPagination.tsx — PropelMapper pager.
//
// Page numbers (with ellipsis truncation) + prev/next, an optional results
// summary ("1–25 of 248") and an optional rows-per-page selector. Pairs with
// PMDataTable / list pages. Controlled: pass `page` + `onPageChange`.
//
// System rules: active page = Pine green (the selected role); hover =
// surface-variant; focus = --pm-focus-ring; <nav aria-label> + aria-current.
//
//   <PMPagination page={page} total={248} pageSize={25}
//     pageSizeOptions={[25,50,100]} onPageChange={setPage} onPageSizeChange={setSize} />

const PMPAG_CSS = `
.pmpag{display:flex;align-items:center;justify-content:space-between;gap:16px;flex-wrap:wrap;font-family:var(--pm-font-sans)}
.pmpag-summary{font:500 13px/1 var(--pm-font-sans);color:var(--pm-fg-2)}
.pmpag-summary b{color:var(--pm-fg-1);font-weight:600}
.pmpag-right{display:flex;align-items:center;gap:18px;flex-wrap:wrap}
.pmpag-sizer{display:flex;align-items:center;gap:8px}
.pmpag-sizer label{font:500 13px/1 var(--pm-font-sans);color:var(--pm-fg-2)}
.pmpag-select{font:600 13px/1 var(--pm-font-sans);color:var(--pm-fg-1);background:var(--pm-surface);border:1.5px solid var(--pm-border);border-radius:var(--pm-radius-m,8px);padding:7px 28px 7px 10px;cursor:pointer;appearance:none;background-image:url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none'><path d='M7 10l5 5 5-5' stroke='%236b7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg>");background-repeat:no-repeat;background-position:right 7px center}
.pmpag-select:focus-visible{outline:none;box-shadow:var(--pm-focus-ring);border-color:var(--pm-primary)}
.pmpag-list{display:flex;align-items:center;gap:3px;list-style:none;margin:0;padding:0}
.pmpag-btn{appearance:none;font-family:inherit;cursor:pointer;border:none;background:transparent;color:var(--pm-fg-2);min-width:36px;height:36px;padding:0 8px;border-radius:var(--pm-radius-m,8px);display:inline-flex;align-items:center;justify-content:center;font:600 13.5px/1 var(--pm-font-sans);transition:background .12s,color .12s}
.pmpag-btn:hover:not(:disabled):not([aria-current="page"]){background:var(--pm-surface-variant);color:var(--pm-fg-1)}
.pmpag-btn:focus-visible{outline:none;box-shadow:var(--pm-focus-ring)}
.pmpag-btn[aria-current="page"]{background:var(--pm-primary);color:#fff;cursor:default}
.pmpag-btn:disabled{opacity:.4;cursor:default}
.pmpag-btn svg{display:block}
.pmpag-ic{display:inline-flex;width:18px;height:18px}
.pmpag-ic svg{display:block;width:100%;height:100%}
.pmpag-ellipsis{min-width:30px;height:36px;display:inline-flex;align-items:flex-end;justify-content:center;color:var(--pm-fg-3);padding-bottom:8px;font-weight:700;user-select:none}
.pmpag--sm .pmpag-btn{min-width:30px;height:30px;font-size:12.5px}
.pmpag--sm .pmpag-ellipsis{height:30px}
`;

function pmpagEnsureCSS() {
  if (typeof document === "undefined" || document.getElementById("pmpag-css")) return;
  const s = document.createElement("style"); s.id = "pmpag-css"; s.textContent = PMPAG_CSS;
  document.head.appendChild(s);
}

function pmpagRange(start: number, end: number) {
  const r = []; for (let i = start; i <= end; i++) r.push(i); return r;
}
function pmpagItems(page: number, pageCount: number, siblingCount: number, boundaryCount: number) {
  const totalNumbers = siblingCount * 2 + 3 + boundaryCount * 2;
  if (pageCount <= totalNumbers) return pmpagRange(1, pageCount);
  const leftSibling = Math.max(page - siblingCount, boundaryCount + 2);
  const rightSibling = Math.min(page + siblingCount, pageCount - boundaryCount - 1);
  const showLeft = leftSibling > boundaryCount + 2;
  const showRight = rightSibling < pageCount - boundaryCount - 1;
  const out: any[] = [];
  out.push(...pmpagRange(1, boundaryCount));
  if (showLeft) out.push("ellipsis-l"); else out.push(...pmpagRange(boundaryCount + 1, leftSibling - 1));
  out.push(...pmpagRange(leftSibling, rightSibling));
  if (showRight) out.push("ellipsis-r"); else out.push(...pmpagRange(rightSibling + 1, pageCount - boundaryCount));
  out.push(...pmpagRange(pageCount - boundaryCount + 1, pageCount));
  return out;
}

// Prev/next consume the custom icon set (window.PM_ICONS chevron-left/-right),
// tinted to currentColor — the system convention (see PMSidebar). No hand-drawn
// SVG. If icon-data.js isn't loaded, falls back to a typographic chevron (a font
// glyph, never a drawn SVG). Requires assets/icons/icon-data.js on the page.
function PMPagChevron({ dir }: any) {
  const I = (typeof window !== "undefined" && (window as any).PM_ICONS) || {};
  const name = dir === "prev" ? "chevron-left" : "chevron-right";
  if (I[name]) {
    return (
      <span
        className="pmpag-ic"
        aria-hidden="true"
        style={{ ["--icon-fg" as any]: "currentColor" }}
        dangerouslySetInnerHTML={{ __html: I[name] }}
      />
    );
  }
  return <span aria-hidden="true" style={{ fontSize: 18, lineHeight: 0, fontWeight: 700 }}>{dir === "prev" ? "\u2039" : "\u203a"}</span>;
}

export function PMPagination({
  page = 1,
  pageCount,
  total,
  pageSize,
  pageSizeOptions = null,
  onPageChange,
  onPageSizeChange,
  siblingCount = 1,
  boundaryCount = 1,
  showSummary = true,
  size = "md",
  "aria-label": ariaLabel = "Pagination",
  className = "",
  style = {},
}: any) {
  pmpagEnsureCSS();
  const count = pageCount != null
    ? pageCount
    : (total != null && pageSize ? Math.max(1, Math.ceil(total / pageSize)) : 1);
  const current = Math.min(Math.max(1, page), count);
  const go = (p: number) => { if (p >= 1 && p <= count && p !== current && onPageChange) onPageChange(p); };
  const items = pmpagItems(current, count, siblingCount, boundaryCount);

  let summary = null;
  if (showSummary && total != null && pageSize) {
    const from = total === 0 ? 0 : (current - 1) * pageSize + 1;
    const to = Math.min(current * pageSize, total);
    summary = <span className="pmpag-summary"><b>{from}–{to}</b> of {total}</span>;
  } else if (showSummary) {
    summary = <span className="pmpag-summary">Page <b>{current}</b> of {count}</span>;
  }

  return (
    <nav className={"pmpag pmpag--" + size + (className ? " " + className : "")} style={style} aria-label={ariaLabel}>
      {summary}
      <div className="pmpag-right">
        {pageSizeOptions && pageSize ? (
          <div className="pmpag-sizer">
            <label htmlFor="pmpag-size">Rows</label>
            <select
              id="pmpag-size"
              className="pmpag-select"
              value={pageSize}
              onChange={(e: any) => onPageSizeChange && onPageSizeChange(Number(e.target.value))}
            >
              {pageSizeOptions.map((o: any) => <option key={o} value={o}>{o}</option>)}
            </select>
          </div>
        ) : null}

        <ul className="pmpag-list">
          <li>
            <button type="button" className="pmpag-btn" aria-label="Previous page" disabled={current <= 1} onClick={() => go(current - 1)}>
              <PMPagChevron dir="prev" />
            </button>
          </li>
          {items.map((it: any, i: number) =>
            typeof it === "string" ? (
              <li key={it + i}><span className="pmpag-ellipsis" aria-hidden="true">…</span></li>
            ) : (
              <li key={it}>
                <button
                  type="button"
                  className="pmpag-btn"
                  aria-label={"Page " + it}
                  aria-current={it === current ? "page" : undefined}
                  onClick={() => go(it)}
                >
                  {it}
                </button>
              </li>
            )
          )}
          <li>
            <button type="button" className="pmpag-btn" aria-label="Next page" disabled={current >= count} onClick={() => go(current + 1)}>
              <PMPagChevron dir="next" />
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
}
